/* eslint-disable @typescript-eslint/camelcase */
// @file Profile Vuex Store.
import window from 'bits/global'
import Vue from 'vue'
import Vuex, { Plugin, StoreOptions } from 'vuex'
import appBarAccount from 'vuexstore/modules/app_bar_account'
import browser from 'vuexstore/modules/browser'
import electronApp, { ElectronAppState } from 'vuexstore/modules/electron_app'
import confirmationDialog from 'vuexstore/modules/global_confirmation_dialog'
import plans from 'vuexstore/modules/plans'
import electronBridgeListener from 'vuexstore/plugins/electron_bridge_listener'
import logger from 'vuexstore/plugins/logger'

type UserProfileState = {
  // Modules
  electronApp?: ElectronAppState
}

Vue.use(Vuex)

const plugins: Plugin<UserProfileState>[] = [electronBridgeListener<UserProfileState>('user_profile')]

if (
  process.env.NODE_ENV === 'development' ||
  (process.env.NODE_ENV === 'test' && ['true', 'yes', '1'].includes(process.env.LOG_VUEX || ''))
) {
  plugins.push(logger)
}

const store: StoreOptions<UserProfileState> = {
  plugins,
  modules: {
    appBarAccount,
    browser,
    confirmationDialog,
    electronApp,
    plans,
  },
  actions: {
    initializeState({ dispatch }): void {
      dispatch('plans/fetchPlans')
      dispatch('plans/fetchAdvertisedQuotas')
    },
  },
}
/* eslint-enable @typescript-eslint/explicit-function-return-type */
if (!window.ww) {
  window.ww = {}
}

const xstore = new Vuex.Store<UserProfileState>(store)
window.ww.xstore = xstore

export default xstore
